import { render, staticRenderFns } from "./selectaddress.vue?vue&type=template&id=0a83457a"
import script from "./selectaddress.vue?vue&type=script&lang=js"
export * from "./selectaddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports